/* unplugin-vue-components disabled */import script from "./auto-settle-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./auto-settle-modal.vue?vue&type=script&setup=true&lang=js"

import "./auto-settle-modal.vue?vue&type=style&index=0&id=6560663a&lang=scss"

const __exports__ = script;

export default __exports__